import { type AppointmentStatus, type hfb } from "@repo/api";

export const isTask = (task: unknown): task is Task =>
  task ? Object.prototype.hasOwnProperty.call(task, "parentTaskType") : false;

export type ParentTaskType = string;

export type SubTaskType = string;

export type TaskContext = "PROJECT" | "CALENDAR" | "WORKSPACE";

export interface Task {
  id: number;
  parentTaskType: ParentTaskType;
  subTaskType: SubTaskType;
  isTimeSet: boolean;
  taskDate?: string;
  taskStartDateTime?: string;
  taskEndDateTime?: string;
  title: string;
  defaultTitle?: boolean; // if true, title is a default title/translation key
  description?: string;
  emailId?: string;
  coworkerEmail?: string;
  assignedTeam?: number;
  opportunityId?: number;
  projectName?: string;
  countryCode?: string;
  projectCountryCode?: string;
  isDone?: boolean;
  created?: {
    createdBy?: string;
    taskCreatedDateTime?: string;
  };
  updated?: {
    updatedBy?: string;
    taskUpdatedDateTime?: string;
  };
  completed?: {
    completedBy?: string;
    taskCompletedDateTime?: string;
  };
  taskDoneDateTime?: string;
  taskCompletedBy?: string;
  taskUpdatedBy?: string;
  taskCreatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
  customerFirstName?: string;
  customerLastName?: string;
  orderId?: string;
  // due date
  isTaskDueBy?: boolean; // if true, taskDate is considered as due date
  // for drop in appointment
  taskActualStartTime?: string;
  taskActualEndTime?: string;
  cmpCode?: string;
  cmpName?: string;
  service?: string;
  hfb?: hfb;
  appointmentStatus?: AppointmentStatus;

  // appointment
  appointmentNumber?: string;
  appointmentId?: number | null;

  // Not sure what's the purpose
  emptySlot?: boolean | null;
  reasonCode?: string | null;
  quotationId?: number | null;
}
